import React from "react";

const FeatureCardView = ({ title, description, brief, list, image, icon, imageLeft = true }) => {

    return (
        <div className={`flex w-full items-stretch gap-4 flex-col lg:flex-row ${imageLeft ? "lg:flex-row" : "lg:flex-row-reverse"}`}>

            {/* IMAGE PANEL */}
            <div
                className="flex justify-center items-center w-full lg:w-1/2 lg:min-h-[610px]"
            >
                {image ? (
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-full object-cover rounded-[30px] box-border"
                        style={{ minHeight: 'inherit' }}
                    />
                ) : (
                    <div className="relative flex flex-col items-center bg-[#111111] rounded-[36px] px-[7px] pt-[10px] pb-[18px] w-[190px] shadow-[0_0_0_2px_#333,0_20px_50px_rgba(0,0,0,0.25)]">
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[72px] h-[20px] bg-[#111111] rounded-b-[14px] z-10" />
                        <div className="w-full rounded-[28px] overflow-hidden bg-[#f5f5f5] min-h-[310px]">
                            <div className="w-full min-h-[310px] bg-gradient-to-b from-[#e8f0fb] to-[#f4f7fd] flex flex-col p-[14px_10px] gap-[7px] box-border">
                                <div className="h-6 bg-[#1a6fd4] rounded-[5px] mb-[6px]" />
                                {[1, 0.75, 1, 0.55, 0.85, 1, 0.65, 0.9].map((w, i) => (
                                    <div key={i} className="h-[9px] bg-[#c7d9f5] rounded-[4px]" style={{ width: `${w * 100}%` }} />
                                ))}
                                <div className="mt-[14px] h-8 bg-[#1a6fd4] rounded-[7px] flex items-center justify-center">
                                    <span className="text-[9px] text-white font-bold font-['Poppins']">CONNECT</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-[72px] h-[3px] bg-[#555] rounded-full mt-[7px]" />
                    </div>
                )}
            </div>

            {/* TEXT PANEL */}
          <div
    className="flex flex-col justify-center items-start rounded-[30px]   bg-[rgba(230,236,255,0.30)] box-border w-full lg:w-1/2 lg:min-h-[610px] p-10 gap-[10px]"
>
                <div className="flex flex-col items-start gap-4 w-full">

                    {/* Icon - optional */}
                    {icon && (
                        <div
                            className="flex justify-center items-center bg-white rounded-[16px] flex-shrink-0 w-[51px] h-[51px] p-[6px_6px_7px_7px]"
                        >
                            <span className="text-[#111827] text-[22px] leading-none">{icon}</span>
                        </div>
                    )}

                    {/* Title - optional */}
                    {title && (
                        <h3
                            className="font-['Poppins'] text-[#000] m-0 text-2xl font-bold leading-[140%]"
                        >
                            {title}
                        </h3>
                    )}

                    {/* Description group */}
                    <div className="flex flex-col items-start gap-4 w-full">

                        {description && (
                            <p className="font-['Poppins'] text-justify text-[#5B5B5B] m-0 text-[15px] font-medium leading-8">
                                {description}
                            </p>
                        )}

                        {brief && (
                            <p className="font-['Poppins'] text-[#5B5B5B] text-justify m-0 text-[15px] font-medium leading-8">
                                {brief}
                            </p>
                        )}

                        {list?.length > 0 && (
                            <ul className="flex flex-col gap-2 m-0 p-0 list-none w-full">
                                {list.map((li, i) => (
                                    <li key={i} className="flex items-start gap-3 font-['Poppins'] text-[#5B5B5B] text-base font-medium leading-8">
                                        <span className="flex-shrink-0 mt-[13px] w-[6px] h-[6px] rounded-full bg-[#1a6fd4]" />
                                        {li}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureCardView;